import React from "react";

var LockupGroup = function LockupGroup(_ref) {
  var groupHeading = _ref.groupHeading,
      children = _ref.children;
  return React.createElement("div", {
    className: "lockup-group"
  }, React.createElement("h2", {
    className: "lockup-group__heading"
  }, groupHeading), React.createElement("ul", {
    className: "lockups"
  }, children));
};

export default LockupGroup;